import * as prodSegment from './generated/prod';
import * as devSegment from './generated/dev';
const segment = process.env.NODE_ENV === 'production' ? prodSegment : devSegment;
export default segment;
